import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import {
  ALL_STAFF_ROLES,
  ALL_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

/**
 * Saved view ids that include every deal field by default — kept in sync
 * with the same constant in `deal-fields-identity.ts`.
 */
const ALL_DEAL_VIEW_IDS = [
  "all-deals",
  "sales-pipeline",
  "not-followed-up-this-week",
  "scheduled-followups",
  "in-progress",
  "closed-deals",
  "overdue-deals",
  "unassigned-deals",
  "at-risk",
  "won-deals",
  "deals-ready-to-invoice",
  "deals-invoiced",
  "recurring-revenue",
  "committed-revenue",
  "my-deals",
] as const;

export const companyDealsFields = defineFieldConfigMap({
  // FIELD: company_id
  company_id: {
    type: "company-select",
    label: "Company",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "companies",
      referencedColumn: "id",
      constraintName: "deals_company_id_fkey",
      onDelete: "CASCADE",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: false,
    editable: true,
    formSpan: 3,
    filterType: "company-select",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    required: true,
    validation: {
      required: "Company is required.",
    },
    placeholder: "Select company",
    icon: "Building",
    groupable: true,
    allowedRoles: [...ALL_STAFF_ROLES],
    mobileDetailSectionId: "company",
    savedViewMembership: ALL_DEAL_VIEW_IDS,
  },
  // FIELD: company_name
  company_name: {
    type: "text",
    label: "Company Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "Building",
    allowedRoles: [...ALL_STAFF_ROLES],
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "company",
  },
});
